module.exports = __webpack_public_path__ + "static/media/emma_vp_door.15cc13af.jpg";